import { Search, VisibilityRounded,CloseRounded as CloseIcon, Save, ListAlt, ShareOutlined } from "@mui/icons-material";
import { Alert, Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, IconButton, Input, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, CustomAutoComplete, InputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, FormActions, FormatPrice, Perfiles,DialogType } from "../../utils/constants";
import { SubItemTable } from "../../components/table/table-components";
import { EmptyState } from "../../components/empty-state";
import { ModalFormGenerador } from "../../components/form/ModalForm";
import * as yup from "yup";
import FeedIcon from '@mui/icons-material/Feed';
import ModalFichaTecnica from "../../components/form/Modal-ficha-tecnica";
import UsbIcon from '@mui/icons-material/Usb';
import { ModalConectorItems } from "../../components/modals/modal-conector-items";
import CustomContextMenu from "../../components/context-menu";


const ModalDetalleProducto = ({
  isVisible,
  Criterios=[],
  productName,
  unidad_medida,
  OnCloseModalDetalle
})=>{

  const [criteriosOrdered,setCriteriosOrdered] = useState([]);


  useEffect(()=>{

    OrderDataToPrint();
  },[Criterios]);

  let OrderDataToPrint = ()=>{
   let NuevosCriterios = [];
    console.log({Criterios});
   const IsKeyInList = (key)=>{

   return  NuevosCriterios.findIndex( Ncriterio => Ncriterio.label === key );
  }
  Criterios.forEach(crt=>{
      let IndexItem = IsKeyInList(crt.descripcion_plan) ;
    if ( IndexItem !== -1){

      NuevosCriterios[IndexItem].SubItems.push({
        label:crt.descripcion_plan,
        value:`${crt.cod_mayor}+${crt.cod_plan}`
      });

    }else{

      NuevosCriterios.push({
        key:`${crt.descripcion_plan}-${crt.cod_mayor}-${crt.cod_plan}`,
        label:String(crt.descripcion_plan).toLowerCase(),
        SubItems:[{
          label:crt.descripcion_mayor,
          value:`${crt.cod_mayor}+${crt.cod_plan}`
        }]
      });

    }

  });
  setCriteriosOrdered(NuevosCriterios);
  console.log({NuevosCriterios});
  }

  return (
    <Dialog
     open={isVisible}
     maxWidth="md"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} >
      <Grid container >
        <Grid item sm={10} md={10}  >
          <Typography variant="h6"  alignContent="center" textAlign="left" >
              {productName} {unidad_medida? '- '+unidad_medida:''}
        </Typography>
      </Grid>
        <Grid item sm={2} md={2} alignContent="center" textAlign="center" >
          <IconButton
            aria-label="close"
            onClick={OnCloseModalDetalle}
            sx={{
              fontWeight:"bold",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      
    </DialogTitle>
    <DialogContent>
          <Grid container >
            <Grid  item sx={12} md={12} >
             <Typography variant="subtitle1" >
                Criterios de clasificacion
             </Typography>
            </Grid>
            <Grid container item sx={12} md={12} >
              {
                criteriosOrdered.map( criterioOrdered=> <Grid key={criterioOrdered.key} item sm={4} md={4} >
                      <CustomAutoComplete
                       multiple
                       disabled
                       id="tags-standard"
                       options={criterioOrdered.SubItems}
                       getOptionLabel={(option) => option.label}
                       isOptionEqualToValue={(option,value)=>{
                       
                        
                        return option.value === value.value;
                       }}
                       defaultValue={criterioOrdered.SubItems}
                       renderInput={(params) => (
                         <TextField
                         
                           {...params}
                           variant="standard"
                           label={criterioOrdered.label}
                          
                         />
                       )}
                      />
                  </Grid> )
              }
             
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={OnCloseModalDetalle} >OK, Cerrar</Button>
        </DialogActions>
    </Dialog>
  )

}










const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const schema = yup.object({
  // detalle: yup.array().required(),
  
 }).required();

export const MaestroProductos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalSobrecosto,setIsVisibleModalSobrecosto] = useState(false);
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [isVisibleFichaTecnica,setIsVisibleFichaTecnica] = useState(false);
  const [isVisibleModalAsociativo,SetIsVisibleModalAsociativo] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({});
  const [itemVentaSeleccionado,setItemVentaSeleccionado ] = useState([]);
  const [entitySobrecosto,setEntitySobrecosto] = useState({});
  const [saved_Productos,setSavedProductos] = useState({});
  const [productOption,setProductOption]  = useState([]);
  const [tiposSobreCostos,setTiposSobreCostos] = useState([]);
  const [fichaTecnica,setFichaTecnica] = useState([]);


    const perfil = profile;
    const disabledActions =  ![Perfiles.administrador,Perfiles["administrador-punto-venta"]].includes( perfil?.cod_perfil );

    useEffect(()=>{

      loadProducts();
      loadListadoTipoSobreCostos();

    },[]);

    useEffect(()=>{
  
      loadProducts( filterSearchPagination.filter_search?false:true );

    },[filterSearchPagination]);


    const loadProducts =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/obtener-productos-paginacion",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data || []]);

     setTotalRows(value?.total || 0);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const loadListadoTipoSobreCostos = async()=>{

      let {data:{value}} = await  AxiosInstance.get("maestros/obtener-tipos-sobrecostos/PRODUCTO");
      setTiposSobreCostos(value);
 
   }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      console.log({InitialFilterSearch});
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{

      setFilterSearchPagination({...filterSearchPagination,filter_search:evt.target.value});
      
     
    }





    const onShowItemVentaConfig = (cod_prod)=>{
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      setItemVentaSeleccionado(product || {});
      SetIsVisibleModalAsociativo(true);
    }

    const SaveAsociateItems = async(items)=>{
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
      await AxiosInstance.post("maestros/actualizar-items-asociados",items);
      await loadProducts(false);
      setItemVentaSeleccionado({});
      SetIsVisibleModalAsociativo(false);

      dispatch({
        type: ActionTypes.setLoadingPage,
        data: false
      });
    }

    const onShowSobrecostoProducto = (cod_prod)=>{
      setIsVisibleModalSobrecosto(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
     
      let dataFormPayload = {
        producto:{value:product.cod,label:product.descripcion},
        detalle_sobrecosto:[],
        nombre_comun_producto:product.nombre_comun_producto,
        calidad_producto:product.calidad_producto
      }

      product.detalle_sobrecosto.forEach(ele=>{
        dataFormPayload[  ele.nombre_sobrecosto ] = Number(ele.valor);
      });

      setEntitySobrecosto(dataFormPayload || {});
    }
    const onCloseModalDetalle = ()=>{
      setIsVisibleModalDetalle(false);
    }

    const OnSaveSobreCompra = async(e,product_id)=>{
      e.preventDefault();
      e.stopPropagation();
       let elementValue =  e.target[0].value;

       await AxiosInstance.post("maestros/set-sobrecompra/"+product_id,{
        "porcentaje":elementValue
       });
       setSavedProductos({...saved_Productos,["porcentaje"+product_id]:"Guardado"});
       setTimeout(() => {
        setSavedProductos({...saved_Productos,["porcentaje"+product_id]:""});
       }, 2000);
       let indexFound = dataSetProdctos.findIndex(prod=>prod.cod == product_id);
       let newDataSet = [...dataSetProdctos];
       newDataSet[indexFound].porcentaje_sobrecompra = elementValue;
       setDataSetProductos( newDataSet );


     
    
    }


    const FormSobreCompra = ({value,id,disabled})=><form id={'form'+id} onSubmit={e=>OnSaveSobreCompra(e,id)} >
       <Input disabled={disabled} min='0' max='100'  name={"porcentaje"+id} id={id} required type="number"  defaultValue={value}  />  <IconButton type="submit"  ><Save /></IconButton>
      {saved_Productos["porcentaje"+id] && <Alert severity="success" >{saved_Productos["porcentaje"+id]}</Alert> } 

    </form>


const onSearchProducto = async (e,value_search) => {
  console.log({value_search});
  if (value_search) {
      try {

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
              search_query: value_search
          });
         setProductOption(value);
      } catch (e) {
          return [];
      }

  }



}

const onSaveDataForm = async (typeAction, dataForm) => {
  setIsVisibleModalSobrecosto(false);
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: true
    });
  let payload = {...dataForm};
  payload["producto"] = dataForm.producto.value;
  payload['sobrecostos'] = [];
  tiposSobreCostos.map( async(tipo_sobre)=>{
    let valueSobreCosto = dataForm[tipo_sobre.descripcion];
    console.log({valueSobreCosto,tipo_sobre});
    payload['sobrecostos'].push({
      cod:tipo_sobre.cod,
      value:valueSobreCosto?valueSobreCosto:0
    })
  });

        try{
          await  AxiosInstance.post("maestros/maestros-editar-configuracion-productos" , payload);
        }catch(e){
            console.log(e.message);
        }
       
       
         await loadProducts();
         dispatch({
          type: ActionTypes.setLoadingPage,
          data: false
        });
}

const openModalFichaTecnica = (cod_prod)=>{
  let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
  console.log(product.ficha_tecnica);
  setFichaTecnica({
    fichaTecnica:product.ficha_tecnica,
    cod_producto:cod_prod
  });
  setIsVisibleFichaTecnica(true); 
}  

const compartirFichaTecnica = (cod_producto)=>{
  console.log({
    cod_producto,
    cod_usuario:profile?.cod
  });
  const urlshare = `${import.meta.env.VITE_CUSTOM_URL}ficha-tecnica/${btoa(String(cod_producto))}/${btoa(String(profile?.cod))}`;
  dispatch({
    type:ActionTypes.setModalInfo,
    data:{
        title:"Compartir ficha tecnica",
        message:"<a href='"+urlshare+"' >"+urlshare+"</a>",
        type:DialogType.peligro,
        isVisible:true
    }
});
}

const configModal = {
  titleModal: "Configuracion del producto",
  buttomsAction:[
    {
      title: "Cancelar",
      buttomProps: {

        type: "buttom",
        color: "secondary",
        onClick: () => setIsVisibleModalSobrecosto(false)
      }
    },
    {
      title: "Guardar cambios",
      color: "primary",
      buttomProps: {
        type: "submit",
        //  onClick:onSaveModData
      }
    }

  ],
  imputs: [
    {
      key: "producto",
      keyValue: "producto",
      label: "Producto",
      component: AutoCompleteInputWithLabel,
      inputProps: {
        name: 'producto',
        fullWidth: true,
        disabled:true,
        isLoading: false,
        onInputChange: onSearchProducto,
        options: productOption|| [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
    {
      key: "nombre_comun_producto",
      keyValue: "nombre_comun_producto",
      label: "Nombre comun",
      component: InputWithLabel,
      inputProps: {
        name: 'nombre_comun_producto',
        fullWidth: true,
       isLoading: false,
        onInputChange: onSearchProducto,
        options: productOption|| [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
    {
      key: "calidad_producto",
      keyValue: "calidad_producto",
      label: "Calidad del producto",
      component: InputWithLabel,
      inputProps: {
        name: 'calidad_producto',
        fullWidth: true,
        isLoading: false,
        onInputChange: onSearchProducto,
        options: productOption|| [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
  
     {
       key:"detalle_sobrecosto",
       keyValue:"detalle_sobrecosto",
       label:"Sobrecostos",
       generateDinamyc:true,
       component:InputWithLabel,
       ArrayList:tiposSobreCostos,
       ArrayInputsProps:{
        key:"cod",
        keyValue:"descripcion",
        type:"number"
       }
      
     },
   

  ],
  arrayInputs:[]
};


    
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"CODIGO ERP",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
        key:"descripcion",
        keyValue:"descripcion",
        label:"Descripcion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"unidad_medida_nombre",
        keyValue:"unidad_medida_nombre",
        label:"Unidad de medida",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"porcentaje_sobrecompra",
        keyValue:"porcentaje_sobrecompra",
        label:"% Sobrecompra",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><FormSobreCompra  disabled={profile?.perfil?.descripcion !== 'administrador'} {...props}/>  ,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {

        key: "tipos_sobre_costos",
        keyValue: "detalle_sobrecosto",
        label: "Sobrecostos",
    
        headerRender: (props) => props.label,
        bodyRender: (props) => <SubItemTable
          cols={[{
            label: "Tipo",
            valueKey: "nombre_sobrecosto",
            keyRow: "cod",
           
          },
          {
            label: "Valor",
            valueKey: "valor",
            keyRow: "cod",
            format:FormatPrice
          }
          ]}
          typeView="horizontal"
          items={props.value} />,
        typeRow: "string",
        sort: false,
        sortFunction: () => { },
        sortStatus: "",
    
      },
      {
      
        key:"acciones",
        keyValue:"cod",
        label:"Acciones",
        headerRender:(props)=>props.label,
        bodyRender:({value,prod_index,info,otherProps})=><>
          <CustomContextMenu
         title_basic="Acciones"
         menuItems={[
          {
            label:"Compartir ficha tecnica",
            onClick:e=>compartirFichaTecnica(value),
            disabled:false

          },
          {
            label:"Ver/Editar producto",
            onClick:e=>onShowSobrecostoProducto(value),
            disabled:false
          },
          {
            label:"Ver/Editar ficha tecnica",
            onClick:e=>openModalFichaTecnica(value),
            disabled:false
          },
          {
            label:"Ver Item de venta",
            onClick:e=>onShowItemVentaConfig(value),
            disabled:profile?.perfil?.descripcion !== 'administrador'

          },
        
          
         ]}
          />
        </>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       

    ];

    return (<>

      <ModalConectorItems
      isOpened={isVisibleModalAsociativo}
      productInfo={itemVentaSeleccionado}
      onClone={e=>SetIsVisibleModalAsociativo(false)}
      onSave={SaveAsociateItems}
      disabled={disabledActions}
      />

    {
      isVisibleModalDetalle &&
      <ModalDetalleProducto
      isVisible={isVisibleModalDetalle}
      productName={productoSeleccionado.descripcion}
      unidad_medida={productoSeleccionado.unidad_medida_nombre}
      Criterios={productoSeleccionado.detalle}
      OnCloseModalDetalle={onCloseModalDetalle}
      disabled={disabledActions}
      />
    }

{
    isVisibleModalSobrecosto &&
    <ModalFormGenerador
      isVisible={isVisibleModalSobrecosto}
      schemaValidator={schema}
      entityValues={entitySobrecosto}
      {
      ...configModal
      }
      onSendForm={onSaveDataForm}
      typeAction={FormActions.MODIFICAR}
    />
  }

  <ModalFichaTecnica  
  disabled={disabledActions}
  dispatch={dispatch}
  setIsVisibleFichaTecnica={setIsVisibleFichaTecnica} 
  isOpen={isVisibleFichaTecnica} 
  dataFichaTecnica={fichaTecnica} 
  updateProdList = {loadProducts}
  />
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar producto"
              inputType="text"
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table stickyHeader>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={columnsTable.length}>
                      <EmptyState
                        title="No hay productos"
                        description="Ajusta la búsqueda o espera a que Acércate cargue el maestro de productos."
                      />
                    </TableCell>
                  </TableRow>
                 ) : dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell key={Col.key} >
                          {<Col.bodyRender value={prod[Col.keyValue]} id={prod.cod}  />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}